import { Trip } from './../classes.js';

export function trip_summary__element(data, edit = false){
	let $content = '';
	let $card = '';
	let $inputs = '';
	let $button = `<button class="btn btn--small btn--marker btn--marker--place" data-marker="${data.marker}">Place Marker</button>`;
	
	if(data.marker){
		$button = `<button class="btn btn--small btn--marker btn--marker--update" data-marker="${data.marker}">Update Marker</button>`;
	}
	
	if(edit){
		
		$content = $('<div/>', {
			'class': 'e card card--event card--event_featured editable',
			'data-el_id': 'summary',
			'data-block_id': 'trip'
		});
		
		
		$card = `
		<div class="card__image">
			<span class="material material-symbols-outlined">
				home_pin
			</span>
		</div>
		<div class="card__content">
			<div class="gc--2 bold">
				<div>
					Set Trip Location (<span class="small latlng_text">[${data.focus_lat}, ${data.focus_lng}]</span> / <span class="small zoom_text">${data.focus_zoom}</span>)
				</div>
			</div>
			<div class="gr--2 g--center">
				${$button}
				<input type="hidden" name="latlng_id" value="${data.latlng_id}" />
				<input type="hidden" name="focus_lat" class="lat" value="${data.focus_lat}" />
				<input type="hidden" name="focus_lng" class="lng" value="${data.focus_lng}" />
				<input type="hidden" name="focus_zoom" class="zoom" value="${data.focus_zoom}" />
			</div>
			<div>
				<div class="form__row">
					<label for="start_date">Start Date</label>
					<input id="start_date" value="${data.start_date}" class="datepicker" type="text" name="start_date" />
				</div>
			</div>
			<div>
				<div class="form__row">
					<label for="end_date">End Date</label>
					<input id="end_date" value="${data.end_date}" class="datepicker" type="text" name="end_date" />
				</div>
			</div>
		</div>
		`;
		
		$content.html($card);
	}else{
		
		
		$content = $('<div/>', {
			'class': 'e card card--event card--event_featured editor',
			'data-el_id': 'summary',
			'data-block_id': 'trip'
		});
		
		$card = `
			<div class="card__image">
				<span class="material material-symbols-outlined">
					home_pin
				</span>
			</div>
			<div class="card__content">
				<div class="gc--3 bold center">${data.start_date} - ${data.end_date}</div>
				<div class="center"><span class="level-title">Physical Level</span> ${get_flag_level(parseInt(data.physical_level), parseInt(data.physical_flagged))}</div>
				<div class="center"><span class="level-title">Gear Level</span> ${get_flag_level(parseInt(data.gear_level), parseInt(data.gear_flagged))}</div>
				<div class="center"><span class="level-title">Prep Level</span> ${get_flag_level(parseInt(data.prep_level), parseInt(data.prep_flagged))}</div>
			</div>
		`;
		
		if(Trip.has_permission){
			$inputs = `
			<input type="hidden" name="start_date" class="lat" value="${data.start_date}" />
			<input type="hidden" name="end_date" class="lat" value="${data.end_date}" />
			<input type="hidden" name="latlng_id" value="${data.latlng_id}" />
			<input type="hidden" name="focus_lat" class="lat" value="${data.focus_lat}" />
			<input type="hidden" name="focus_lng" class="lng" value="${data.focus_lng}" />
			<input type="hidden" name="focus_zoom" class="zoom" value="${data.focus_zoom}" />
			`;
		}
		$content.append($card, $inputs);
	}
	
	return $content;
	
	//render the datepicker
	$(function() {
		$('.datepicker').datepicker();
	});
}

function get_flag_level(val, flagged){
	let display = ``;
	
	switch(val){
		case 1:
		case 2:
			display = `<span class="flag bg--primary">${flagged ? '~ ' : ''}Low</span>`;
			break;
		case 3:
		case 4:
			display = `<span class="flag bg--lemon_verbena">${flagged ? '~ ' : ''}Medium Low</span>`;
			break;
		case 5:
		case 6:
			display = `<span class="flag bg--lemon_verbena">${flagged ? '~ ' : ''}Medium</span>`;
			break;
		case 7:
		case 8:
			display = `<span class="flag bg--quaternary">${flagged ? '~ ' : ''}Medium High</span>`;
			break;
		case 9:
		case 10:
			display = `<span class="flag bg--quaternary">${flagged ? '~ ' : ''}High</span>`;
			break;
		default:
			display = `<span class="flag bg--tertiary">${flagged ? '~ ' : ''}N/A</span>`;
	}
	
	return display;
}